import { render, staticRenderFns } from "./CustomerReceivableReportComponent.vue?vue&type=template&id=94a13776&scoped=true"
import script from "./CustomerReceivableReportComponent.vue?vue&type=script&lang=js"
export * from "./CustomerReceivableReportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a13776",
  null
  
)

export default component.exports